"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnsubscribeReason = void 0;
let UnsubscribeReason = exports.UnsubscribeReason = /*#__PURE__*/function (UnsubscribeReason) {
  UnsubscribeReason["UNKNOWN"] = "unknown";
  UnsubscribeReason["UNWANTED"] = "unwanted";
  UnsubscribeReason["SPAM"] = "spam";
  UnsubscribeReason["NEVER_SIGNED_UP"] = "never_signed_up";
  UnsubscribeReason["OTHER"] = "other";
  return UnsubscribeReason;
}({});